import { useEffect as useReactEffect } from 'react'

export const useEffect = useReactEffect

export default useEffect
